import { MutationRouteBarrelVals } from '@core/api';
import type { EditLockRoutes } from '@web/constants/editLock';
import { UrlFromParams } from '@web/hooks/useSlabQuery';

import { pageClientId } from './pageClientId';

// fetch with keepalive is the only request the browser lets outlive an unloading page;
// a release that never left is harmless, since the lease expires on its own.
export const releaseEditLocksOnPageHide = (
  route: EditLockRoutes['release'],
  ids: string[],
  accessToken: string,
): void => {
  fetch(
    UrlFromParams({
      pathParams: {},
      queryParams: {},
      urlSplits: MutationRouteBarrelVals[route].urlSplits,
    }),
    {
      method: 'DELETE',
      keepalive: true,
      headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids, clientId: pageClientId }),
    },
  ).catch((): void => undefined);
};
